export const BxFilterIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.66666 7.33317H11.3333V8.6665H4.66666V7.33317ZM2.66666 4.6665H13.3333V5.99984H2.66666V4.6665ZM6.66666 9.99984H9.33332V11.3332H6.66666V9.99984Z" fill="#697586" />
    </svg>
  )
}